var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002,25.25h-19c-1.5166,0-2.75-1.2334-2.75-2.75v-19c0-1.5166,1.2334-2.75,2.75-2.75h19c1.5166,0,2.75,1.2334,2.75,2.75 v19C25.2502,24.0166,24.0168,25.25,22.5002,25.25z M3.5002,2.25c-0.6895,0-1.25,0.5605-1.25,1.25v19c0,0.6895,0.5605,1.25,1.25,1.25 h19c0.6895,0,1.25-0.5605,1.25-1.25v-19c0-0.6895-0.5605-1.25-1.25-1.25H3.5002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0812,13.75H6.9191c-0.1381,0-0.25-0.1119-0.25-0.25v-1c0-0.1381,0.1119-0.25,0.25-0.25h12.1621 c0.1381,0,0.25,0.1119,0.25,0.25v1C19.3312,13.6381,19.2193,13.75,19.0812,13.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0812,9.1455H6.9191c-0.1381,0-0.25-0.1119-0.25-0.25v-1c0-0.1381,0.1119-0.25,0.25-0.25h12.1621 c0.1381,0,0.25,0.1119,0.25,0.25v1C19.3312,9.0336,19.2193,9.1455,19.0812,9.1455z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0812,18.3545H6.9191c-0.1381,0-0.25-0.1119-0.25-0.25v-1c0-0.1381,0.1119-0.25,0.25-0.25h12.1621 c0.1381,0,0.25,0.1119,0.25,0.25v1C19.3312,18.2426,19.2193,18.3545,19.0812,18.3545z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuControl);
export default __webpack_public_path__ + "static/media/Menu_Control.7f68f90b3160a46c62c99b319afc7a49.svg";
export { ForwardRef as ReactComponent };